import React from 'react';
import { cn } from 'src/utils/className';

export type BadgeVariant =
  | 'success'
  | 'warning'
  | 'error'
  | 'info'
  | 'primary'
  | 'secondary';

interface BadgeProps {
  variant?: BadgeVariant;
  className?: string;
  children: React.ReactNode;
}

export const Badge: React.FC<BadgeProps> = ({
  variant = 'success',
  className,
  children,
}) => {
  const base =
    'inline-flex flex items-center px-2 py-2 rounded text-xs font-medium leading-none';
  const variants = {
    success: 'bg-success-100 text-success-700',
    warning: 'bg-warning-100 text-warning-700',
    error: 'bg-error-100 text-error-700',
    info: 'bg-info-100 text-info-700',
    primary: 'bg-primary-100 text-primary-700',
    secondary: 'bg-secondary-100 text-secondary-700',
  };
  return (
    <span className={cn(base, variants[variant], className)}>{children}</span>
  );
};
